<mat-card class="mcd-card view-all-detail-card">
  <mat-card-header class="mcd-card-header-dateModified">
        <mat-card-title
          style="font-weight: bold; "
          >
          
        <button style="background-color: #3F51B51A;color: #3F51B5;border: none;padding: 5px 11px; border-radius: 4px;font-weight: 600;font-size: 14px;" (click)="goBack()">
          <img
            src="/assets/images/back to list.svg"
          />
          Back
        </button>
         <span>
            <img
              src="/assets/images/global approved icon.svg"
              style="margin-left: 16px; margin-right: 8px"
              />  
          </span>
          <span style="font-size: 16px;">View Global Approved Solution</span></mat-card-title
        >
   
      </mat-card-header>
  <mat-card-content class="mcd-card-content nrbes-view">
   


     <!-- new detail UI starts here  -->

         <div *ngIf="!loading" style="padding: 20px;background-color: #f7f9fa;">
          <div class="review-page-container">
            <!-- Breadcrumb -->
            <div class="breadcrumbs clearfix">
              <div class="breadcrumbs-inner">
                <ul>
                  <li>
                    <a
                      routerLink="/view-all-standards"
                      routerLinkActive="active"
                      >All</a
                    >
                  </li>
                  <li class="separator">/</li>
                  <li class="active">{{ grsDetail.standard.title }}</li>
                  <li
                    style="
                      float: right;
                      border: 1px solid #3f51b5;
                      padding: 6px 10px;
                      border-radius: 4px;
                    "
                  >
                    <img src="/assets/images/social-sharing 1.svg" style=" margin-right: 4px" />

                    <a
                     style="
                    color: #3f51b5;
                    text-decoration: none;
                    cursor: pointer;
                    font-weight: 700;
                  "
                      (click)="openShareModal()"
                      >Share
                    </a>
                  </li>
                  <li
                    style="
                      float: right;
                      border: 1px solid #3f51b5;
                      padding: 6px 10px;
                      border-radius: 4px;
                      margin-right: 10px;
                    "
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="margin-bottom: 2px; margin-right: 2px"
                    >
                      <path
                        d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                        stroke="#3C74E0"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                        stroke="#3C74E0"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <a
                      style="
                    color: #3f51b5;
                    text-decoration: none;
                    cursor: pointer;
                    font-weight: 700;
                  "
                      (click)="downloadExcel()"
                      >Download
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- End Breadcrumb -->
            <!-- <div class="header"> -->
            <!-- <div class="stamp">{{ data.stampText }}</div> -->
            <!-- </div> -->

            <div
              *ngIf="isPartlyInEffect"
              style="
                background-color: #eef1fc;
                border: 1px solid #d6ddf5;
                border-radius: 6px;
                padding: 12px 16px;
                margin-bottom: 16px;
              "
            >
              <div style="color: #3f51b5; font-weight: 700; font-size: 14px">
                This Standard is partly in effect
              </div>
              <div style="color: #555; font-size: 13px; margin-top: 2px;font-weight: 500">
                {{ partlyInEffectMessage }}
              </div>
            </div>

            <div class="info-main">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                      margin-bottom: 20px;
                "
              >
                <h1 class="lastpage-title">
                  {{ grsDetail.standard.title }}
                </h1>
                <img src="../../assets/images/global-approved-sol-badge.svg" />
              </div>
              <div style="display: flex">
                <div class="info-column left-column">
                  <div class="info-row">
                    <span class="reviewPage-icon date"></span>
                    <span class="label left-label"
                      >Available From</span
                    >
                    <span class="value">{{
                          grsDetail.standard.newRestaurantsEffectiveFrom
      ? (grsDetail.standard.newRestaurantsEffectiveFrom | date:'dd, MMM yyyy')
      : '--'

                    }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon date2"></span>
                    <span class="label left-label"
                      >Existing Restaurant Effective Date</span
                    >
                    <span class="value">{{
                      grsDetail.standard.effectiveFrom != ''
                        ? (grsDetail.standard.effectiveFrom | date: "dd, MMM yyyy")
                        : '--'
                    }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon standardType"></span>
                    <span class="label left-label">Standard Type</span>
                    <span class="value">Global Approved Solution</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon createdOn"></span>
                    <span class="label left-label">Last Updated</span>
                    <span class="value">{{
                      grsDetail.standard.lastModifiedDate | date: "dd, MMM yyyy"
                    }}</span>
                  </div>

                  <div
                    class="info-row"
                    *ngIf="userRole == userRoleEnum.MarketAdmin"
                  >
                    <span class="reviewPage-icon marketStandard"></span>
                    <span class="label left-label">Add to Market Standard</span>
                    <span class="value market-standard-toggle-cell">
                      <mat-slide-toggle
                        [checked]="grsDetail.isInNrbes"
                        [disabled]="grsDetail.isInNrbes || loading"
                        (change)="onAddToMarketStandardToggle($event)"
                      ></mat-slide-toggle>
                    </span>
                  </div>

                   <div class="info-row">
                    <span class="reviewPage-icon category"></span>
                    <span class="label left-label">Category</span>
                    <span class="value">
                      {{ grsDetail.standard.category?.name }}
                    </span>
                    
                  </div>

                  <!-- <div class="info-row">
                                <span class="icon clock-icon"></span>
                                <span class="label">Last Modified</span>
                                <span class="value">{{
                                  data.lastModified
                                }}</span>
                              </div> -->
                </div>

                <div class="divider"></div>

                <div class="info-column right-column">
                 
                  <div class="info-row">
                    <span class="reviewPage-icon location"></span>
                    <span class="label right-label">Location</span>
                    <span class="value">{{ allLocations }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon Sublocation"></span>
                    <span class="label right-label">Sub Location</span>
                    <span class="value">{{
                      subLocations != "" ? subLocations : "--"
                    }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon keyContact"></span>
                    <span class="label right-label">Last Updated</span>
                    <span class="value">{{
                      grsDetail.standard.lastModifiedDate | date: "dd, MMM yyyy"
                    }}</span>
                  </div>

                  <div class="info-row">
                                <span class="reviewPage-icon keyContact"></span>
                                <span class="label right-label">Key Contact</span>
                                <span class="value">{{ keyContactEmailResolved ? keyContactEmailResolved : "--" }}</span>
                              </div>
                </div>
              </div>
            </div>

            <div class="description-section">
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                "
              >
                <h2 class="section-title"> Global Approved Solution Description</h2>
                <button class="copyIcon">
                  <img
                    (click)="
                      copyText(grsDetail.standard.newRestaurantDescription);
                      $event.stopPropagation()
                    "
                    src="../../assets/images/copy text.svg"
                    alt=""
                  />
                </button>
              </div>
              <p class="description-text">
                {{ grsDetail.standard.newRestaurantDescription }}
              </p>
            </div>

            <!-- <div class="description-section">
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                "
              >
                <h2 class="section-title">
                   Existing Restaurant Operation Standard
                </h2>
                <button class="copyIcon">
                  <img
                    (click)="
                      copyText(grsDetail.standard.description);
                      $event.stopPropagation()
                    "
                    src="../../assets/images/copy text.svg"
                    alt=""
                  />
                </button>
              </div>
              <p class="description-text">
                {{ grsDetail.standard.description }}
              </p>
            </div> -->

            <div class="details-section" style="margin-top: 20px" *ngIf="grsDetail.standard.note">
              <div class="details-header" (click)="toggleDetails()">
                <div class="details-title-wrapper">
                  <div>
                    <span class="toggle-icon">
                      <img
                        *ngIf="!detailsExpanded"
                        src="../../assets/images/s-add 1.svg"
                        alt="Expand"
                        style="margin-bottom: 3px" />

                      <img
                        *ngIf="detailsExpanded"
                        src="../../assets/images/cross (2).svg"
                        alt="Collapse"
                        style="margin-bottom: 3px"
                    /></span>
                    <!-- <span class="details-icon">☑</span> -->
                    <span class="details-title" [ngClass]="{ 'details-title-expanded': detailsExpanded }"> Standard Details </span>
                  </div>
                  <div *ngIf="detailsExpanded">
                    <img
                      (click)="
                        copyText(grsDetail.standard.note);
                        $event.stopPropagation()
                      "
                      src="../../assets/images/copy text.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div class="details-content" [class.expanded]="detailsExpanded">
                <div [innerHTML]="getDetails()" class="detail-section"></div>
              </div>
            </div>

            <div
              class="details-section"
              style="margin-top: 20px"
              *ngIf="grsDetail.standard.additionalInformation"
            >
              <div class="details-header" (click)="toggleDetails2()">
                <div class="details-title-wrapper">
                  <div>
                    <span class="toggle-icon">
                      <img
                        [ngStyle]="{
                          display: additionalInfoExpanded ? 'none' : '',
                        }"
                        *ngIf="!additionalInfoExpanded"
                        src="../../assets/images/s-add 1.svg"
                        alt="Expand"
                        style="margin-bottom: 3px" />
                      <img
                        [ngStyle]="{
                          display: !additionalInfoExpanded ? 'none' : '',
                        }"
                        *ngIf="additionalInfoExpanded"
                        src="../../assets/images/cross (2).svg"
                        alt="Collapse"
                        style="margin-bottom: 3px"
                    /></span>
                    <!-- <span class="details-icon">☑</span> -->
                    <span class="details-title" [ngClass]="{ 'details-title-expanded': additionalInfoExpanded }"> Additional Info </span>
                  </div>
                  <div *ngIf="additionalInfoExpanded">
                    <img
                      (click)="
                        copyText(grsDetail.standard.additionalInformation);
                        $event.stopPropagation()
                      "
                      src="../../assets/images/copy text.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div
                class="details-content"
                [class.expanded]="additionalInfoExpanded"
              >
                <div
                  [innerHTML]="getAdditionalInfo()"
                  class="detail-section"
                ></div>
              </div>
            </div>

            <div
              *ngIf="
                linksList?.length > 0 ||
                hardwareDescription
              "
              class="bottom-sections"
              [class.single-column]="
                (linksList?.length > 0 &&
                  !hardwareDescription) ||
                (!(linksList?.length > 0) &&
                  hardwareDescription)
              "
            >
              <div
                class="resources-section"
                *ngIf="linksList?.length > 0"
              >
                <div class="section-header">
                  <h2 class="section-heading">
                    Resources and Supporting Information
                  </h2>
                  <span
                    matTooltip="Information about Resources and Supporting Information"
                    style="
                      background-image: url(&quot;/assets/images/Vector.svg&quot;);
                      background-repeat: no-repeat;
                      background-size: auto;
                      background-position: center;

                      padding: 10px;
                    "
                  ></span>
                </div>
                <div class="links-list">
                  <a
                    *ngFor="let link of linksList"
                    [href]="link.url"
                    class="resource-link"
                    target="_blank"
                  >
                    {{ link.title }}
                  </a>
                </div>
              </div>

              <div
                class="hardware-section"
                *ngIf="hardwareDescription"
              >
                <div class="section-header">
                  <h2 class="section-heading">
                    Global Approved Hardware/Equipment
                  </h2>
                  <span
                    matTooltip="Information about Global Approved Hardware/Equipment"
                    style="
                      background-image: url(&quot;/assets/images/Vector.svg&quot;);
                      background-repeat: no-repeat;
                      background-size: auto;
                      background-position: center;

                      padding: 10px;
                    "
                  ></span>
                </div>
                <div class="hardware-content">
                  <p
                    class="hardware-text"
                    style="margin: 0; white-space: pre-line;"
                  >
                    {{ hardwareDescription }}
                  </p>
                </div>
              </div>
            </div>

            <!-- <div
                          >
                            <div class="section-header">
                              <h2 class="section-heading">
                                Global Approved Solutions
                              </h2>
                              <span class="info-icon-circle">?</span>
                            </div>
                            <div class="links-list">
                              <div class="dmos-cards-grid">
                                <div
                                  class="dmos-standard-card"
                                  *ngFor="
                                    let item of selectFromDepenedentStandard
                                  "
                                >
                                  <div class="dmos-card-header">
                                    <h3 class="dmos-card-title">
                                      {{ item.title }}
                                    </h3>
                                    <span
                                      class="dmos-category-badge dmos-building-site"
                                      >{{ item.category.name }}</span
                                    >
                                  </div>
                                  <div class="dmos-card-body">
                                    <p class="dmos-card-description">
                                      {{ item.description }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
            <div class="row" style="margin-top: 30px">
             
                <div class="btn-wrapper" style="display: flex;gap: 20px;">
                  <div class="prev-button" *ngIf="!grsDetail.isFirst">
                    <a
                      class="nextPrevButtons"
                      href="javascript:void(0)"
                      (click)="slide(grsDetail.standard.id, false)"
                    >
                      <img src="/assets/images/arrow-right 2.svg" />
                      Previous Standard
                    </a>
                  </div>
                  <div class="next-button" *ngIf="!grsDetail.isLast">
                    <a
                      class="nextPrevButtons"
                      href="javascript:void(0)"
                      (click)="slide(grsDetail.standard.id, true)"
                    >
                      Next Standard
                      <img src="/assets/images/arrow-right 1 (2).svg" />
                    </a>
                  </div>
                
              </div>


            </div>
          </div>
        </div>


        <!-- new detail UI ends here -->

  

    <!-- <button
      class="mcd-btn mcd-btn-primary"
      [disabled]="grsDetail.isInNrbes"
      *ngIf="userRole == userRoleEnum.MarketAdmin && !isImpersonating"
      (click)="
        addToNrbes(grsDetail.standard.id, grsDetail.standard.standardTypeId)
      "
      mat-raised-button
      color="accent"
    >
      Add To National Standard
    </button> -->
    <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  </mat-card-content>
</mat-card>
<app-share-link-modal
  *ngIf="isShareModalOpen"
  [itemTitle]="shareModalTitle"
  [itemSubtitle]="shareModalSubtitle"
  [shareUrl]="shareModalUrl"
  (closeModal)="isShareModalOpen = false"
></app-share-link-modal>
